import dayjs from "dayjs";

import Table from "react-bootstrap/Table";

import { formatPatientAddress } from "@/utils/formatPatientAddress";
import { DiagnosticHypothesis } from "@/@types/sintegrada/sintegradaServerApi/DiagnosticHypothesis";

import { TableSkeletons } from "@/components/TableSkeletons";

import "./styles.scss";

type Props = {
	isLoading?: boolean;
	results: DiagnosticHypothesis[];
};

export function DiagnosticHypothesisTable({ isLoading, results }: Props) {
	const hasData = Boolean(results?.length);

	return (
		<Table id="diagnostic-hypothesis-table">
			<thead>
				<tr className="fw-bold">
					<th>Dt. do Atendimento</th>
					<th>Nome do paciente</th>
					<th>Dt. Nascimento</th>
					<th>Sexo</th>
					<th>Endereço</th>
					<th>Classificação</th>
					<th>Profissional</th>
					<th>CID</th>
				</tr>
			</thead>

			<tbody>
				{isLoading ? (
					<TableSkeletons numberOfCells={7} numberOfRows={15} />
				) : hasData ? (
					results.map((result, index) => {
						const { patient } = result;
						
						const attendanceStartDate = patient.attendance_start
							? dayjs(patient.attendance_start).format("DD/MM/YYYY HH:mm")
							: "N/A";

						const birthday = result.patient.birthday
							? dayjs(result.patient.birthday).format("DD/MM/YYYY")
							: "N/A";

						const address = formatPatientAddress(
							patient.street,
							patient.house_number,
							patient.neighborhood,
							patient.city,
							patient.state,
							patient.zip_code,
						);

						return (
							<tr key={`attendance-${index}`}>
								<td>{attendanceStartDate}</td>
								<td>{patient.name || "N/A"}</td>
								<td>{birthday}</td>
								<td>{patient.sex || "N/A"}</td>
								<td className="text-uppercase">{address}</td>
								<td>{result.risk.name || "N/A"}</td>
								<td>{result.professional_name || "N/A"}</td>
								<td className="icd-column">
									{result.icd_code || "N/A"} - {result.icd_description || "N/A"}
								</td>
							</tr>
						);
					})
				) : (
					<tr>
						<td colSpan={12} className="text-center text-black-50 fw-bold">
							Nenhum resultado encontrado
						</td>
					</tr>
				)}
			</tbody>
		</Table>
	);
}
